// FullscreenVideoModal.jsx
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import api from "../services/api"; // your axios instance
import { VIDEO_URL } from "./config";

const FullscreenVideoModal = ({ onClose, filename }) => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const res = await api.get(`/api/get-secure-video-url/${filename}`, {

          withCredentials: true,
        });
        setVideoUrl(res.data.video_url); // or res.data.url if you return signed URL
      } catch (err) {
        onClose(); // close modal or show error
      }
    };

    fetchVideoUrl();
    
  }, [filename, onClose]);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
      <div
          onContextMenu={(e) => e.preventDefault()}
          className="relative w-full h-full"
        >
        <button onClick={onClose} className="absolute top-4 right-4 text-white text-2xl z-50">
          ×
        </button>

        {videoUrl ? (
          <video
              key={filename} 
              controls
              autoPlay
              className="w-full h-full object-contain"
              src={`${VIDEO_URL}/${videoUrl}`}
              crossOrigin="use-credentials"
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()} // Disable right-click on the video itself
            >
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className="text-white text-center mt-20">Loading video...</div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default FullscreenVideoModal;